import { differenceInDays } from 'date-fns';

import { formatMoney } from '@spa/shared/utils';

const SHORT_TERM_FIXED = 'fixed';

export const validateShortTermPenalty = (t, language, startDate, endDate, penalty) => {
  if (!startDate || !endDate) {
    return { warning: null };
  }

  const { nights_threshold: nights } = penalty;
  const selectedNights = differenceInDays(endDate, startDate);

  if (nights < 0 || selectedNights >= nights) {
    return { warning: null };
  }

  if (penalty.type === SHORT_TERM_FIXED) {
    const { amount, currency_code: currency } = penalty.value;

    return {
      warning: t(
        'This listing has a penalty for selecting less than {{days}} days. Rent will be increased by {{money}} a month',
        { days: nights, money: formatMoney(amount, currency, language) }
      )
    };
  }

  return {
    warning: t(
      'This listing has a penalty for selecting less than {{days}} days. Rent will be increased by {{percentage}} a month',
      { days: nights, percentage: `${penalty.percentage * 100}%` }
    )
  };
};
